import { AppContext } from "components/App/AppContext";
import { getLOTLabel } from "components/ContactCard/ContactEdit";
import { useContext } from "react";
import { ContactTypeCode } from "./types";
import { DEFAULT_LOT_LABEL } from "./utils";

export const useLotLabel = (contactType?: ContactTypeCode) => {
    const portalConfig = useContext(AppContext);

    return getLOTLabel(portalConfig, contactType) || DEFAULT_LOT_LABEL;
};
